export const metadata = {
    'about-us': {
      title: 'About Us | Before Bots Takeover',
      description: 'We build small business software for the Fortune 1,000,000.',
      image: '/og-about-us.jpg',
      type: 'article'
    },
    'our-ethos': {
      title: 'Our Ethos | Before Bots Takeover',
      description: 'Explore the core values and principles of Before Bots Takeover.',
      image: '/og-ethos.jpg',
      type: 'article'
    },
    'contacts': {
      title: 'Contact Before Bots Takeover',
      description: 'Whether you have questions, ideas, or need support, we’re here to help.',
      image: '/og-contact.jpg',
      type: 'website'
    },
    'terms-of-service': {
      title: 'Terms of Service | Before Bots Takeover',
      description: 'Our Terms of Service outline the guidelines for using our website. Understand how we ensure a transparent and fair relationship with our users.',
      image: '/og-terms.jpg',
      type: 'article'
    },
    'privacy-policy': {
      title: 'Privacy Policy | Before Bots Takeover',
      description: 'Your privacy matters to us. This policy explains how Before Bots Takeover collects, uses, and protects your data. Learn about our commitment to safeguarding your information.',
      image: '/og-privacy.jpg',
      type: 'article'
    },
    'copyright': {
      title: 'Copyright Information | Before Bots Takeover',
      description: 'Learn about Before Bots Takeover’s copyright policies and intellectual property guidelines. Understand how our content and products can be used responsibly.',
      image: '/og-copyright.jpg',
      type: 'article'
    },
    'icon': {
      title: 'Icon | Before Bots Takeover',
      description: 'Our icon.',
      image: '/og-icon.jpg',
      type: 'image'
    },
    'bbt-logo': {
      title: 'Logo | Before Bots Takeover',
      description: 'Our logo.',
      image: '/og-logo.jpg',
      type: 'image'
    },
    default: {
      title: 'Before Bots Takeover - For the Fortune 1,000,000',
      description: 'We build technology that works for people, not the other way around.',
      image: '/og-default.jpg',
      type: 'website'
    }
  };